import { Link } from "react-router-dom";
import { Users, ArrowUpRight, Phone } from "lucide-react";
import { imgUrl } from "../../lib/api";
import { waLink, roomMessage, telHref } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppFloat";
import { SectionHeading } from "./SectionHeading";

export const RoomCta = ({ content, room, className = "" }) => {
  const wa = waLink(content, roomMessage(content, room));
  if (!wa) {
    return (
      <a href={telHref(content.phone)} data-testid={`room-phone-btn-${room.slug}`} className={`btn-gold ${className}`}>
        <Phone size={15} /> Ligar: {content.phone}
      </a>
    );
  }
  return (
    <a href={wa} target="_blank" rel="noopener noreferrer" data-testid={`room-whatsapp-btn-${room.slug}`} className={`btn-gold ${className}`}>
      <WhatsAppIcon className="w-4 h-4" /> {content.btn_room}
    </a>
  );
};

const RoomCard = ({ room, content, index }) => {
  const cover = room.photos[0];
  return (
    <article data-testid={`room-card-${room.slug}`} className={`group relative bg-[#080808] border border-zinc-800/80 hover:border-[#D4AF37]/40 transition-colors duration-500 ${index % 2 === 1 ? "md:mt-20" : ""}`}>
      <Link to={`/acomodacoes/${room.slug}`} className="block relative aspect-[4/3] overflow-hidden" data-testid={`room-card-link-${room.slug}`}>
        {cover ? (
          <img src={imgUrl(cover.thumb)} alt={cover.title || room.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
        ) : (
          <div className="w-full h-full grid place-items-center bg-[#111111] font-caps text-xs text-zinc-500">Vienna Palace</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-transparent to-transparent" />
        {cover?.is_sample && <span className="absolute top-4 left-4 text-[10px] uppercase tracking-widest bg-black/60 px-2 py-1 text-zinc-300">Imagem ilustrativa</span>}
      </Link>
      <div className="p-6 sm:p-8 -mt-10 relative">
        <p className="font-caps text-[10px] text-[#D4AF37]">{String(index + 1).padStart(2, "0")}</p>
        <h3 className="font-display text-3xl mt-2 text-zinc-50">{room.name}</h3>
        {room.description && <p className="mt-4 text-sm text-zinc-400 leading-relaxed line-clamp-3">{room.description}</p>}
        {room.amenities?.length > 0 && (
          <ul className="mt-5 flex flex-wrap gap-2" data-testid={`room-amenities-${room.slug}`}>
            {room.amenities.slice(0, 6).map((a) => (
              <li key={a} className="text-[11px] tracking-wide px-3 py-1 rounded-full border border-zinc-700 text-zinc-300">{a}</li>
            ))}
          </ul>
        )}
        <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-zinc-400">
          {room.capacity && <span className="flex items-center gap-2"><Users size={15} className="text-[#D4AF37]" /> {room.capacity}</span>}
          {room.price && <span data-testid={`room-price-${room.slug}`} className="font-display text-xl text-[#E6C687]">{room.price}</span>}
        </div>
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <RoomCta content={content} room={room} className="!py-3" />
          <Link to={`/acomodacoes/${room.slug}`} data-testid={`room-details-btn-${room.slug}`} className="btn-outline-gold !py-3">
            Ver detalhes <ArrowUpRight size={15} />
          </Link>
        </div>
      </div>
    </article>
  );
};

export const Accommodations = ({ content, rooms }) => (
  <section id="acomodacoes" data-testid="accommodations-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHeading eyebrow="Hospedagem" title={content.accommodations_title} intro={content.accommodations_intro} />
      {rooms.length === 0 ? (
        <p className="mt-12 text-zinc-500" data-testid="accommodations-empty">Em breve, nossas acomodações estarão disponíveis aqui. Consulte-nos pelo telefone {content.phone}.</p>
      ) : (
        <div className="mt-16 grid md:grid-cols-2 gap-8 lg:gap-12">
          {rooms.map((r, i) => <RoomCard key={r.id} room={r} content={content} index={i} />)}
        </div>
      )}
    </div>
  </section>
);
